<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">
    <div class="card SmallForm rounded">
      <div class="card-body MyCardBody rounded-bottom text-center">
        <p>You are not authorized to access this page!</p>
      </div>
      <div class="form-group col-12 mt-3">
        <button
          class="btn btn-block btn-secondary"
          type="button"
          (click)="goHome()"
        >
          <span> Close </span>
        </button>
      </div>
    </div>
  </div>
</div>
